module.exports = __webpack_public_path__ + "img/home-title.4bdf9f6a.png";